import { render, staticRenderFns } from "./OrderedBy.vue?vue&type=template&id=938d6b62&scoped=true&"
import script from "./OrderedBy.vue?vue&type=script&lang=ts&"
export * from "./OrderedBy.vue?vue&type=script&lang=ts&"
import style0 from "./OrderedBy.vue?vue&type=style&index=0&id=938d6b62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938d6b62",
  null
  
)

export default component.exports